import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver asked where to fuel.
 */
export const fuelRequestV1 = tmsEventKind(
  { category: "request", kind: "fuelRequest", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      city: z.string().nullable(),
      state: z.string().nullable(),
    },
  },
);

export const FuelRequestV1Schema = fuelRequestV1.schema;
export const FuelRequestV1FactsSchema = fuelRequestV1.facts;

export type FuelRequestV1 = z.infer<typeof FuelRequestV1Schema>;
export type FuelRequestV1Facts = z.infer<typeof FuelRequestV1FactsSchema>;

/** Every version of `fuelRequest`, keyed by version. What `catalog.ts` places under `request`. */
export const fuelRequest = { 1: fuelRequestV1 } as const;
